import {Modal, View, Dimensions} from 'react-native';
import React, {Component} from 'react';
import styled from 'styled-components/native';

const Background = styled.View`
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
`;

const Wrap = styled.View`
  height: 100%;
  width: 100%;
`;

export default class PDFViewer extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }
  render() {
    let self = this;
    let url = 'data:application/pdf;base64,' + this.props.base64;
    return <iframe src={url} style={this.props.style}></iframe>;
  }
}
